import {
  Action,
  CustomTagType,
  DialogPosition,
  DockType,
  ErrorCodes,
  OperationType,
  Position,
  WindowType
} from "puzzle";
import ReportDialog from "../components/SubmissionsList/ActionToolbar/UploadDialog/ReportDialog/ReportDialog";

export const uploadDialogCollectReports: Action = [{
  args: ['uploadFiles'],
  moduleName: 'UploadDialog',
  name: 'updateUpdatedFiles'
}, {
  data: {
    isUpload: true,
    template: {
      bind: {
        url: "{uploadDialogUrl}",
        params: '{uploadParams}'
      }
    }
  },
  mappingName: 'fileUploadResult',
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{fileUploadResult}'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          responseData: '{responseData.response}'
        }
      }
    },
    moduleName: 'ErrorHandler',
    name: 'prepareErrorStrings',
    args: ['responseData', 'endpointPrefix'],
    mappingName: 'errorStrings',
    type: OperationType.addOperationData
  }, {
    placeholders: {
      template: {
        bind: {
          close: '{errorStrings.close}',
          text: '{errorStrings.text}',
          title: '{errorStrings.title}',
          warningType: '{errorStrings.warningType}'
        }
      }
    },
    items: [{
      operations: [{
        moduleName: 'UploadDialog',
        name: 'reset'
      }],
      btnName: 'errorHandler.close',
      btnConfig: {
        pos: Position.start
      }
    }, {
      btnName: 'ESCAPE',
      operations: [{
        moduleName: 'UploadDialog',
        name: 'reset'
      }]
    }],
    className: '{warningType}',
    text: 'errorHandler.text',
    title: 'errorHandler.title',
    type: OperationType.warning
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    dispatcherIds: ['mainDispatcher'],
    type: OperationType.stopAll
  }],
  type: OperationType.conditional
}, {
  condition: `_.get({fileUploadResult},"processId")`,
  conditionOperations: [{
    data: {
      template: {
        pingData: null,
        bind: {
          pingParam: '{fileUploadResult.processId}',
        }
      }
    },
    type: OperationType.data
  }, {
    items: ['pingParam', 'pingData'],
    type: OperationType.syncDispatchersDataItem
  }, {
    data: {
      template: {
        bind: {
          taskId: `_.get({fileUploadResult},"taskId")`
        }
      }
    },
    moduleName: 'UploadDialog',
    args: ['taskId'],
    name: 'setTaskId',
    type: OperationType.addOperationData
  }, {
    name: 'getReport',
    type: OperationType.action
  }],
  elseOperations: [{
    moduleName: 'UploadDialog',
    name: 'collectUploadErrors',
    args: ['fileUploadResult']
  }, {
    name: 'continueWithUpload',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const continueWithUpload: Action = [{
  data: {
    template: {
      files: null
    }
  },
  moduleName: 'UploadDialog',
  name: 'startFileUpload',
  args: ['files']
}];


export const getReport: Action = [{
  condition: '{pingData} && {pingData.processingFinished}',
  conditionOperations: [{
    moduleName: 'UploadDialog',
    name: 'collectResponseData',
    args: ['pingData']
  }, {
    name: 'continueWithUpload',
    type: OperationType.action
  }],
  elseOperations: [{
    condition: '!_.get({pingData}, "response.data.errors")}',
    conditionOperations: [{
      actionType: {
        dispatcherId: "batchPingDispatcher",
        delay: 1000
      },
      data: {
        template: {
          bind: {
            processId: '{pingParam}'
          }
        }
      },
      name: 'pingGetReport',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const pingGetReport: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '{uploadReportGetUrl} + {processId}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'pingData',
  type: OperationType.request,
}, {
  items: ['pingData'],
  type: OperationType.syncDispatchersDataItem
}, {
  data: {
    template: {
      bind: {
        responseData: '{pingData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'getReport',
  type: OperationType.action
}];

export const reportDialog: Action = [{
  condition: '!{reopenDialogFlow}',
  conditionOperations: [{
    index: DialogPosition.previous,
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  elseOperations: [{
    index: DialogPosition.last,
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}, {
  name: 'removePersistentUploadData',
  type: OperationType.action
}, {
  dispatcherIds: ['batchPingDispatcher'],
  type: OperationType.unlink
}, {
  actionType: {
    dispatcherId: 'mainDispatcher'
  },
  name: 'openReportDialog',
  args: ['submissionData', 'taskId'],
  type: OperationType.action
}];

/**
 * Quick fix for ---- PDII-38336 New UI | G+S | Report dialog buttons become unresponsive ----
 * when opening multiple dialogs, actions get override by next dialog actions
 * So we shift actions by 7 places, when G+S dialog is open Report Dialog actions don't get overridden.
 */
const fakeReportDialogButtons = [{
  btnName: 'fakeHiddenAction0',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction1',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction2',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction3',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction4',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction5',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction6',
  operations: [],
  btnConfig: {
    hidden: true
  }
}, {
  btnName: 'fakeHiddenAction7',
  operations: [],
  btnConfig: {
    hidden: true
  }
}];

export const openReportDialog: Action = [{
  condition: '{submissionData}',
  conditionOperations: [{
    data: {
      template: {
        asSubName: true,
        bind: {
          submissionName: '{submissionData.submissionName}'
        }
      }
    },
    persistent: ['submissionName'],
    type: OperationType.data
  }, {
    data: {
      template: {
        asSubId: true,
        bind: {
          submissionId: '{submissionData.submissionId}'
        }
      }
    },
    persistent: ['submissionId'],
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  children: [{
    render: ReportDialog,
    propArgs: ['submissionData', 'reportData', 'uploadedTargetIds', 'taskId', 'activeDialog']
  }],
  className: 'xxxl upload-report',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, ...fakeReportDialogButtons, {
    btnName: 'reportDialog.close',
    operations: [{
      name: 'refreshApp',
      type: OperationType.action
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'reportDialog.report',
    btnConfig: {
      className: 'k-flex-row-reverse',
      iconClass: 'tp-icon tp-download',
      themeColor: 'primary',
      pos: Position.end
    },
    close: false,
    operations: [{
      moduleName: 'ReportDialog',
      name: 'prepareDownloadJson',
      mappingName: 'downloadReportParams',
      type: OperationType.addOperationData
    }, {
      name: 'downloadReportRequest',
      args: ['downloadReportParams'],
      type: OperationType.action
    }, {
      condition: '{activeDialog} === "ReopenDialog"',
      conditionOperations: [{
        name: 'refreshReopenDialog',
        type: OperationType.action
      }],
      elseOperations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        name: 'refreshApp',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }, {
    btnName: 'reportDialog.closeAndContinue',
    close: false,
    operations: [{
      name: 'refreshReopenDialog',
      type: OperationType.action
    }],
    btnConfig: {
      hidden: true,
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'reportDialog.returnAll',
    close: false,
    operations: [{
      evaluate: true,
      name: '{returnActionName}',
      type: OperationType.action
    }],
    btnConfig: {
      className: 'k-flex-row-reverse',
      themeColor: 'primary',
      hidden: true,
      pos: Position.end
    }
  }, {
    btnName: 'reportDialog.completeAll',
    btnConfig: {
      className: 'k-flex-row-reverse',
      themeColor: 'primary',
      hidden: true,
      pos: Position.end
    },
    close: false,
    operations: [{
      evaluate: true,
      name: '{completeActionName}',
      type: OperationType.action
    }]
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      condition: '{activeDialog} !== "ReopenDialog"',
      conditionOperations: [{
        name: 'refreshApp',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }],
  title: 'reportDialog.title',
  type: OperationType.dialog
}, {
  condition: '!{reopenDialogFlow} && {uploadedTargetIds.length}',
  conditionOperations: [{
    name: 'ipcFlow',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '{reopenDialogFlow}',
  conditionOperations: [{
    name: 'updateFooterForUploadReopen',
    type: OperationType.action
  }, {
    persistent: ['reopenDialogFlow'],
    type: OperationType.removePersistentData,
  }],
  type: OperationType.conditional
}];

export const refreshReopenDialog: Action = [{
  moduleName: 'ReportDialog',
  name: 'getUploadedFiles',
  mappingName: 'uploadedFiles',
  type: OperationType.addOperationData
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  moduleName: 'ReopenDialog',
  name: 'setUploadedTargets',
  args: ['uploadedFiles'],
  type: OperationType.addOperationData
}]

export const updateFooterForUploadReopen: Action = [{
  data: {
    hideCloseButton: true,
    hideCloseAndContinueButton: false
  },
  buttons: [{
    name: 'reportDialog.close',
    hidden: '{hideCloseButton}'
  }, {
    name: 'reportDialog.closeAndContinue',
    hidden: '{hideCloseAndContinueButton}'
  }],
  type: OperationType.updateDialog
}]

export const updateReportDialogFooter: Action = [{
  buttons: [{
    name: 'reportDialog.completeAll',
    hidden: '!{additionalProps.promoteDemoteEnabled} || {flagConfiguration.multiplePhasesSelected} || {flagConfiguration.multipleWorkflowsSelected}'
  }, {
    name: 'reportDialog.returnAll',
    hidden: '!{additionalProps.promoteDemoteEnabled} || ({flagConfiguration.multiplePhasesSelected} || {flagConfiguration.multipleWorkflowsSelected} || !{flagConfiguration.demotionPhase})'
  }],
  type: OperationType.updateDialog
}];

export const reportDialogCompleteAllVendor: Action = [{
  moduleName: 'ReportDialog',
  name: 'getParamsForComplete',
  mappingName: 'submissionData',
  type: OperationType.addOperationData
}, {
  data: {
    actionName: 'promote',
    closeUploadReportDialog: true
  },
  persistent: ['closeUploadReportDialog'],
  type: OperationType.addPersistentData
}, {
  name: 'addPingUrl',
  type: OperationType.action
}, {
  data: {
    executionModuleName: 'ReportDialog',
    promoteFilesAction: 'completeActionWarnings',
    selectAll: false,
    mandatoryCompleteParams: true
  },
  name: 'task_complete_jobPhase_files',
  args: ['actionName', 'executionModuleName', 'promoteFilesAction', 'submissionData', 'selectAll', 'mandatoryCompleteParams'],
  type: OperationType.action
}];

export const reportDialogReturnAllVendor: Action = [{
  moduleName: 'ReportDialog',
  name: 'getParamsForComplete',
  mappingName: 'submissionData',
  type: OperationType.addOperationData
}, {
  data: {
    actionName: 'demote',
    closeUploadReportDialog: true,
  },
  persistent: ['closeUploadReportDialog'],
  type: OperationType.addPersistentData
}, {
  name: 'addPingUrl',
  type: OperationType.action
}, {
  data: {
    executionModuleName: 'ReportDialog',
    promoteFilesAction: 'completeActionWarnings',
    selectAll: false,
    mandatoryCompleteParams: true
  },
  name: 'task_complete_jobPhase_files',
  args: [
    'actionName',
    'executionModuleName',
    'promoteFilesAction',
    'submissionData',
    'selectAll',
    'mandatoryCompleteParams'
  ],
  type: OperationType.action
}];

export const addPingUrl: Action = [{
  moduleName: 'ReportDialog',
  name: 'getCompleteSupplierURL',
  args: ['actionName'],
  mappingName: 'completeSupplierURL',
  type: OperationType.addOperationData
}, {
  persistent: ['completeSupplierURL'],
  type: OperationType.addPersistentData
}];

export const reportDialogCompleteAll: Action = [{
  data: {
    actionName: 'promote',
    selectAll: false,
    executionModuleName: 'ReportDialog'
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getPreviousPhase',
  mappingName: 'previousPhase',
  type: OperationType.addOperationData
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'setFlagConfiguration',
  args: ['actionName']
}, {
  name: 'startPromoteFiles',
  type: OperationType.action
}];

export const reportDialogReturnAll: Action = [{
  data: {
    actionName: 'demote',
    selectAll: false,
    executionModuleName: 'ReportDialog'
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'setFlagConfiguration',
  args: ['actionName']
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getPreviousPhase',
  mappingName: 'previousPhase',
  type: OperationType.addOperationData
}, {
  name: 'startPromoteFiles',
  type: OperationType.action
}];

export const downloadReportRequest: Action = [{
  data: {
    template: {
      bind: {
        url: '{downloadReportUrl}',
        params: '{downloadReportParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'pingData',
  type: OperationType.request,
}, {
  data: {
    template: {
      bind: {
        responseData: '{pingData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'downloadToaster',
  type: OperationType.action
}, {
  name: 'pingForDownloadReport',
  args: ['pingData'],
  type: OperationType.action
}];

export const pingForDownloadReport: Action = [{
  ping: {
    template: {
      bind: {
        url: '{downloadReportUrl}',
        params: '{pingData}'
      }
    }
  },
  pingBreakCondition: ['errors'],
  pingCondition: 'processingFinished',
  delay: 1000,
  pingErrorOperations: [{
    data: {
      template: {
        responseData: {
          response: {
            bind: {
              data: '{pingResponseDownloadData}',
              status: '{responseStatus}'
            }
          }
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  mappingName: 'pingResponseDownloadData',
  download: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/download/' + {pingResponseDownloadData.downloadId}",
      }
    }
  },
  withIndicator: false,
  pingOperations: [],
  type: OperationType.pingDownload
}];


export const ipcFlow: Action = [{
  condition: '{additionalProps.ipcEnabled}',
  conditionOperations: [{
    data: {
      template: {
        promoteRequestData: {
          bind: {
            promotedTargetIds: '{uploadedTargetIds}'
          }
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'promoteNotification',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        requestData: {
          bind: {
            targetIds: '{uploadedTargetIds}'
          }
        }
      }
    },
    type: OperationType.data
  }, {
    data: {
      template: {
        method: 'post',
        url: '/submissions/massActionConfiguration',
        bind: {
          params: '{requestData}'
        }
      },
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'flagConfiguration',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{flagConfiguration}',
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    waitForModule: true,
    moduleName: 'ReportDialog',
    name: 'setMassActionConfiguration',
    args: ['flagConfiguration']
  }, {
    name: 'updateReportDialogFooter',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const closePreviousWindow: Action = [{
  index: DialogPosition.previous,
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}]